import { SIGN_IN_MODAL } from '~/constants/dynamicModals';

export const COOKIE_NAME_SOCIAL_SIGNUP = 'trackSocialSignup';
export const COOKIE_NAME_SOCIAL_SIGNUP_SOURCE = 'trackSocialSignupSource';
export const COOKIE_NAME_REDIRECT_SIGNUP = 'signupRedirect';
export const COOKIE_NAME_SAVED_JOB_TITLE = 'savedJobTitle';

export const commonModalNames = Object.freeze({
  SIGN_IN: SIGN_IN_MODAL,
  SIGN_UP: 'sign-up',
});

export const WAR_ROOM_COMMISSION_TOOLTIP = 'war-room-commission-tooltip';
export const NEW_SUPER_INVITES_TOOLTIP = 'new_super_invites_tooltip';
export const WAR_ROOM_MEGATHREADS_TOOLTIP = 'war-room-megathreads-tooltip';
export const WAR_ROOM_DEALS_TOOLTIP = 'war-room-deals-tooltip';
export const PORTFOLIO_HEADER_MENU_TOOLTIP = 'portfolio_header_menu_tooltip';
export const TOP_FLEX_VACANCIES_TOOLTIP = 'top_flex_vacancies_tooltip';

// disable for now
// first element will be shown last
export const ONBOARDING_TOOLTIPS: string[] = [
  PORTFOLIO_HEADER_MENU_TOOLTIP,
  // WAR_ROOM_DEALS_TOOLTIP,
  // WAR_ROOM_MEGATHREADS_TOOLTIP,
  // NEW_SUPER_INVITES_TOOLTIP,
  // WAR_ROOM_COMMISSION_TOOLTIP,
];

export const loadingState = Object.freeze({
  IDLE: 'idle',
  SUBMITTING: 'submitting',
  SUCCESS: 'success',
  ERROR: 'error',
});

// $route.query may have important bits like search term on request board
// we want to preserve them when closing modal windows
export const RESERVED_QUERY_PARAMS = [
  'term',
  'page',
  'category',
  'prefix',
  'selectedVacancyId',
  'selectedEmployerId',
  'mrk',
  'query',
  'sgpt_sid',
  'sgpt_type',
];
